import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M5 16h3.04l-1.52-2.03z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.78 11.63l1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6l-4.22 5.63zM5 16l1.52-2.03L8.04 16H5z"
})), 'FilterHdrTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterHdrTwoTone.js
// module id = 3649
// module chunks = 2